import {Message} from "src/app/core/class/message";
import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {MatDialog} from "@angular/material";
import {ActivatedRoute, Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {CommonService} from "src/app/core/services/common.service";
import {NotificationService} from "src/app/core/services/notification.service";
import {SelectDocumentTypeComponent} from "../../document/select-document-type/select-document-type.component";
import {DocumentTypeService} from "src/app/core/services/document-type.service";
import {DocumentTypeEnterprise} from "src/app/core/class/DocumentTypeEnterprise";
import {DocumentTemplateService} from "src/app/core/services/document-template.service";
import {ContractLotService} from "src/app/core/services/contract-lot.service";
import {ConfigSigningFlowMohaComponent} from "../config-signing-flow-moha/config-signing-flow-moha.component";
import {SignatureConfigLotMohaComponent} from "../signature-config-lot-moha/signature-config-lot-moha.component";
import {ContractLot} from "../../../../../../shared/models/contract-lot";
import {TemplateFileService} from 'src/app/core/services/template-file.service';
import {DialogPreviewPdfComponent} from '../../document-management/dialog-preview-pdf/dialog-preview-pdf.component';
import {ProcessingService} from 'src/app/core/services/processing.service';
import {WarningComponent} from "src/app/shared/components/warning/warning.component";
import {Location} from "@angular/common";
import {ErrorCode} from "src/app/core/constants/error-code";
import {forkJoin,interval, Subscription} from 'rxjs';
import {DocumentService} from 'src/app/core/services/document.service';
import {WarningDialogComponent} from 'src/app/modules/dashboard/home/home-enterprise/contract-lot/warning-dialog/warning-dialog.component';
import {LotType} from "src/app/core/constants/lot-type";
import {EnumRoleUser} from "src/app/core/constants/common"
import {CreateContractService} from "src/app/core/services/create-contract.service";
import { AutoEnterpriseService } from "src/app/core/services/auto-enterprise.service";
import { WarningSmsContractService } from "src/app/core/services/warning-sms-contract.service";
import {BlockUI, NgBlockUI} from "ng-block-ui";

@Component({
  selector: "app-add-lot-moha",
  templateUrl: "./add-lot-moha.component.html",
  styleUrls: ["./add-lot-moha.component.scss"],
})
export class AddLotMohaComponent implements OnInit, OnDestroy {
  @ViewChild('configSign', {static: false}) configSignComponent: ConfigSigningFlowMohaComponent;
  @ViewChild('signatureConfig', {static: false}) signatureConfigComponent: SignatureConfigLotMohaComponent;

  @ViewChild(ConfigSigningFlowMohaComponent, {
    read: ConfigSigningFlowMohaComponent,
    static: true
  }) configSigningFlowComponent: ConfigSigningFlowMohaComponent;

  @ViewChild('expansionData', {static: false}) expansionData: any;

  @BlockUI() blockUI: NgBlockUI;
  isShowStep = false;
  current = 0;
  fileName: string = "";
  fileBase64: string = "";
  documentTypeEnterprise: DocumentTypeEnterprise;
  serviceType: any;
  public templateId: number;
  createSide: any = null;
  dataFootNote: any = null;

  currentTab: number = 0;
  id: string = null;
  contractLot: ContractLot = null;
  dynamicColumns: any = []
  tableData: any = []
  lotGroupColumns: { name: string; span: number }[] = [];
  lotGroupRowColumns: string[] = [];
  private EventWarningContractSubscription: Subscription;
  viewMode: 'create' | 'view' = 'create';

  templateFile: any = null;
  name: string = null;
  processing: any = null;

  errorFile: boolean = false;

  subcription: Subscription = new Subscription();

  userSign: string = null;

  checked = true;
  DATA_RECORD_USER_PERFORM_SIGN = [];
  checkFirtClick = true;
  public cecaEnable: boolean;
  isNotAttestedUser: boolean = false;

  dataUserSign: any = null;
  isBuyContract1Mb: boolean = false;
  isBuyContract10Mb: boolean = false;
  isHaveDeleteCreata: boolean = false;
  maxNumberOfCustomerInFlow: number = 1;
  public noteWarning = "";
  isContainCustomerSignature = false;

  RECORD_SHARE_PARTNER = [];
  filteredPartyOptions: any = []
  timeOutQueryServer: any;
  inputPartyValue: string = ''
  nzCheckLoadingParty2 = false;
  private pollingSubscription: Subscription = null;

  constructor(
    public commonService: CommonService,
    private dialog: MatDialog,
    private router: Router,
    public notificationService: NotificationService,
    private toast: ToastrService,
    public message: Message,
    private route: ActivatedRoute,
    private documentTypeService: DocumentTypeService,
    public documentTemplateService: DocumentTemplateService,
    public contractLotService: ContractLotService,
    public templateFileService: TemplateFileService,
    public processingService: ProcessingService,
    public location: Location,
    private createContractService: CreateContractService,
    public documentService: DocumentService,
    public autoEnterpriseService: AutoEnterpriseService,
    private warningSmsContractService: WarningSmsContractService,
    ) {
    this.checked = true;
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
  }

  
  /** Tinh % tu contractDetails (DONE + ERROR la da xu ly xong) */
  private updateProcessingFromDetails(contractDetails: any[]): void {
    const details = contractDetails || [];
    const total = details.length;
    const done = details.filter(d => d.status === 'DONE' || d.status === 'ERROR').length;
    const percent = total > 0 ? Math.round((done / total) * 100) : 0;
    this.processing = { id: this.id, type: LotType.CONTRACT_MOHA_LOT, percent };
  }

  /** Bat dau polling moi 3 giay khi lo dang xu ly */
  private startPolling(): void {
    if (this.pollingSubscription) return; // Tranh lap polling
    this.pollingSubscription = interval(3000).subscribe(() => {
      this.contractLotService.getContractLotById(this.id).subscribe(res => {
        if (!res || !res.data) return;
        const status = res.data.status;
        if (status === 'NEW' || status === 'PROCESSING') {
          this.updateProcessingFromDetails(res.data.contractDetails);
        } else {
          // Xu ly xong - dung polling va an thanh tien trinh
          this.stopPolling();
          this.processing = null;
          this.contractLot = res.data;
          this.maxNumberOfCustomerInFlow = res.data.maxNumberOfCustomerInFlow;
        }
      });
    });
  }

  /** Dung polling */
  private stopPolling(): void {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
      this.pollingSubscription = null;
    }
  }

  ngOnDestroy(): void {
    this.EventWarningContractSubscription.unsubscribe();
  }

  ngOnInit() {
    this.id = this.route.snapshot.params.id;
    this.cecaEnable = localStorage.getItem('cecaEnable') == 'true';

    if (!this.id) {
      this.createContractService.resetData();
    }

    if (this.id) {
      this.viewMode = 'view';

      /**
       * Subscibe data queue emit from websocket
       */
        // let count = 0;
      const readRecordTaskSub = this.processingService.recordSocketContractQueue.subscribe(record => {
          try {
            // console.log(`🌈 ~ vcl message websocket này: \n${JSON.stringify(record, null, 4)}`)
            // console.log('💦',JSON.stringify(this.contractLot, null, 4))
            this.contractLot.contractDetails.map(el => {
              if (el.id == record.idEncrypt) {
                el.status = record.status;
                el.errorMessage = record.errorMessage;
                return el;
              } else return el;
            })
          } catch (e) {
            console.log(`🚀`, e)
          }

        })

      const proccesingTaskSub = this.processingService.processingTask.subscribe(ref => {
        const process = ref.find(item => item.id.replace(/\=/g, '') === this.id.replace(/\=/g, '') && item.type === LotType.CONTRACT_MOHA_LOT);
        if (process) {
          // if (this.processing && this.processing.percent !== process.percent) {
          this.contractLotService.getContractLotById(this.id).subscribe(res => {
            if (!res || !res.data) {
              return;
            }
            if(res.data.contractSharePartners){
              this.RECORD_SHARE_PARTNER = res.data.contractSharePartners.map(item => {
                return {
                  ...item,
                  email: item.receiveEmail,
                  name: item.receiveName,
                  phone: item.receivePhone,
                }
              })
            }
            this.contractLot = res.data;
            this.maxNumberOfCustomerInFlow = res.data.maxNumberOfCustomerInFlow;
          })
          // }
          this.processing = process;
        } else if (this.processing) {
          this.contractLotService.getContractLotById(this.id).subscribe(res => {
            if (!res || !res.data) {
              return;
            }
            if(res.data.contractSharePartners){
              this.RECORD_SHARE_PARTNER = res.data.contractSharePartners.map(item => {
                return {
                  ...item,
                  email: item.receiveEmail,
                  name: item.receiveName,
                  phone: item.receivePhone,
                }
              })
            }
            this.contractLot = res.data;
            this.maxNumberOfCustomerInFlow = res.data.maxNumberOfCustomerInFlow;
          });
          if (this.processing.percent == 100)
            this.processing = null;
        }
      });
      this.subcription.add(proccesingTaskSub);
      this.subcription.add(readRecordTaskSub);
      this.contractLotService.getContractLotById(this.id).subscribe(res => {
        if (!res || !res.data) {
          return;
        }
        if(res.data.contractSharePartners){
          this.RECORD_SHARE_PARTNER = res.data.contractSharePartners.map(item => {
            return {
              ...item,
              email: item.receiveEmail,
              name: item.receiveName,
              phone: item.receivePhone,
            }
          })
        }
        this.contractLot = res.data;
        this.maxNumberOfCustomerInFlow = res.data.maxNumberOfCustomerInFlow;

        // Neu lo dang duoc xu ly (status NEW hoac PROCESSING), hien thi thanh tien trinh va bat dau polling
        if (res.data.status === 'NEW' || res.data.status === 'PROCESSING') {
          this.updateProcessingFromDetails(res.data.contractDetails);
          this.startPolling();
        } else {
          this.stopPolling();
          this.processing = null;
        }

        this.fileName = this.contractLot.importFileName ? this.contractLot.importFileName : null;
        this.dataFootNote = this.contractLot.signatures ? this.contractLot.signatures : null;
        if (this.contractLot.enterpriseSign) {
          this.createSide = this.contractLot.enterpriseSign.find(item => item.isCreatedSide && item.isCreatedSideJoin);
          if (this.createSide && this.contractLot.userSign) {
            const userSign = this.contractLot.userSign.find(item => item.role === 1);
            this.userSign = userSign && userSign.name ? userSign.name : null;
          }
        }
        this.DATA_RECORD_USER_PERFORM_SIGN = this.contractLot.userSign;
        this.documentTypeService.findById(this.contractLot.documentTypeEnterpriseId).subscribe(resDT => {
          if (!res || !res.data) {
            return;
          }
          this.isShowStep = true;
          this.documentTypeEnterprise = resDT.data;
          this.getServiceTypes();
          this.getDocumentTemplateById();
        });
      })
      forkJoin([
        this.documentTypeService.getInfoProperties(null, false),
        this.contractLotService.getPropertiesContractLotById(this.id)
      ]).subscribe((res) => {
        if(!res[0].success){
          this.toast.error(res[0].message)
          return;
        }
        if(!res[1].success){
          this.toast.error(res[1].message)
          return;
        }
        this.dynamicColumns = res[0].data
          .filter(e => e.inputType !== "HEADER")
          .sort((first, second) => Number(first.order || 0) - Number(second.order || 0));
        this.buildGroupColumns(res[0].data);
        this.tableData = this.mapContractReportRows(res[1].data);

        console.log('[LotReport] res[0].data (get-all):', res[0].data);
        console.log('[LotReport] nhóm:', this.lotGroupColumns);
      })
      
    } else {
      this.documentService.getDocumentsType(true).subscribe(rs => {
        if (rs.data && rs.data.length) {
          this.onSelectedFormClick();
          return;
        }
        const warningDialog = this.dialog.open(WarningDialogComponent, {
          width: '40%',
          data: this.message.getMessage('messages.warning_not_template_for_lot')
        });
        warningDialog.afterClosed().subscribe(() => {
          this.location.back();
        })
      });
    }
    this.warningSmsContractService.getDataQuantityAndWarningQuantitySmsContractOfEnterpriseByService();
    this.EventWarningContractSubscription = this.warningSmsContractService.statusUpdated.subscribe(
      (response) => {
        this.isBuyContract1Mb = response.isBuyContract1Mb;
        this.isBuyContract10Mb = response.isBuyContract1Mb;
      }
    );
  }

  decodeId(id: string) {
    const idDecode = atob(id);
    const findNumber = idDecode.match(/[0-9]{1,}/g);
    if (findNumber && findNumber.length) {
      return Number(findNumber[findNumber.length - 1]);
    }
    return null;
  }

  onSelectedFormClick() {
    const dialogRef = this.dialog.open(SelectDocumentTypeComponent, {
      width: "30%",
      disableClose: true,
      data: {mode: 'lot', isDocumentMoha: true }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (typeof result !== "undefined") {
        this.documentTemplateService.checkLotTemplate(result.data.documentTypeEnterprise.id).subscribe(res => {
          if (res && res.code === ErrorCode.TemplateNotForLot) {
            const message = this.message.getMessage('messages.confirm_template_not_for_lot');
            const dialogConfirm = this.dialog.open(WarningComponent, {
              width: "30%",
              disableClose: true,
              data: message
            });
            dialogConfirm.afterClosed().subscribe(ref => {
              if (ref) {
                this.isShowStep = true;
                this.documentTypeEnterprise = result.data.documentTypeEnterprise;
                this.getServiceTypes();
                this.getDocumentTemplateById();
                if (this.configSignComponent && this.configSignComponent.RECORD_PARTY_SIGN) {
                  this.genSignature(this.documentTypeEnterprise.id, this.configSignComponent.RECORD_PARTY_SIGN)
                }
              }
            });
            return;
          }
          this.isShowStep = true;
          this.documentTypeEnterprise = result.data.documentTypeEnterprise;
          this.getServiceTypes();
          this.getDocumentTemplateById();
          if (this.configSignComponent && this.configSignComponent.RECORD_PARTY_SIGN) {
            this.genSignature(this.documentTypeEnterprise.id, this.configSignComponent.RECORD_PARTY_SIGN)
          }
        })
      }
    });
  }

  uploadFile() {
    const inputFile = document.getElementById("file");
    inputFile.click();
  }

  async onChangeFile(event: any) {
    const temp = (<HTMLInputElement>document.getElementById("file")).files[0];
    const accept: RegExp = /(\.xlsx)$/;
    if (!accept.exec(temp.name)) {
      this.toast.error(
        this.message.getMessage("messages.error_file_type_excel")
      );
      return;
    }
    if (temp.size > 10000000) {
      this.toast.error(this.message.getMessage("messages.error_file_size"));
      return;
    }
    this.fileName = temp.name;
    this.fileBase64 = await this.getBase64(temp) as any;
  }

  deleteFile() {
    this.fileName = null;
    this.fileBase64 = null;
  }

  getServiceTypes() {
    this.documentTypeService
      .getServiceTypesMoha(this.documentTypeEnterprise.enterpriseId, true)
      .subscribe((rs) => {
        if (rs == null || rs.data == null) {
          return 0;
        }
        this.serviceType = rs.data.find((data) => {
          return data.id === this.documentTypeEnterprise.serviceType;
        });

        if(this.serviceType && this.serviceType.employmentContractTerm){
          this.documentTypeEnterprise.laborContractType = this.serviceType.employmentContractTerm == 'LIMITED' ? 'Xác định thời hạn' : 'Không xác định thời hạn'
        }
      });
  }

  getDocumentTemplateById() {
    this.documentTemplateService.getDocumentTemplateById(this.documentTypeEnterprise.id).subscribe(res => {
      if (!res || !res.data) {
        return;
      }
      if (res.data.configFlowSignList) {
        this.dataUserSign = res.data.configFlowSignList.map((data: any) => ({
          ...data,
          role: data.typeInSignFlow === 'SIGN' ? EnumRoleUser.USER_SIGN : EnumRoleUser.USER_APPROVER,
          enterpriseSignId: localStorage.getItem('enterpriseId'),
          isCreatedSide: true,
          isSignDigitalCertificate: data.typeInSignFlow === 'SIGN' ? false : data.isSignDigitalCertificate
        }));
      }

      if (this.dataUserSign && this.dataUserSign.filter((data) => data.typeInSignFlow === 'SIGN').length) {
        this.userSign = this.dataUserSign.find((data) => data.typeInSignFlow === 'SIGN').name;
      }
      if (this.dataUserSign) {
        this.dataUserSign.forEach(data => {
          delete data.id;
          delete data.typeInSignFlow
        });
      }
      this.templateId = res.data.documentTemplateId;
      this.name = res.data.name;
      this.getTemplateFile();
    })
  }

  getTemplateFile() {
    this.templateFileService.getTemplateFile(this.templateId).subscribe(res => {
      console.log(res);

      if (!res || !res.data || !res.data.length) {
        return;
      }
      this.templateFile = res.data[0];
    });
  }

  setMaxNumberOfPartner(value: number) {
    this.maxNumberOfCustomerInFlow = value;
    if (!this.maxNumberOfCustomerInFlow || this.maxNumberOfCustomerInFlow <= 0) {
      this.maxNumberOfCustomerInFlow = 1;
      this.isContainCustomerSignature = false;
    } else {
      this.isContainCustomerSignature = true;
    }
    this.noteWarning = this.commonService.format(this.message.getMessage('contract_lot.note_warning'), this.maxNumberOfCustomerInFlow)
  }

  downloadFileTemplate() {
    this.contractLotService.generateImportFile({
      documentTypeEnterpriseId: this.documentTypeEnterprise.id,
      maxNumberOfPartner: this.maxNumberOfCustomerInFlow,
      type: 'CONTRACT_MOHA',
    })
      .subscribe(res => {
        this.downLoadFile(res, 'application/octet-stream', this.documentTypeEnterprise.name + '.xlsx');
      })
  }

  downLoadFile(data: any, type: string, fileName: string) {
    const blob = new Blob([data], {type});
    if (window.top.navigator.msSaveOrOpenBlob) {
      // Store Blob in IE
      window.top.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      // Store Blob in others
      const tA = document.body.appendChild(document.createElement('a'));
      tA.href = URL.createObjectURL(blob);
      tA.download = fileName;
      tA.style.display = 'none';
      tA.click();
      tA.parentNode.removeChild(tA);
    }
  }

  async submit() {
    this.sortOrderApproveSign();
    this.errorFile = false;
    if (!this.fileBase64) {
      this.toast.error(this.message.getMessage('validation.error_not_have_file_lot'));
      return;
    }
    if (this.configSignComponent.validateErrorSetUser()) {
      this.expansionData.open();
      this.toast.error(this.message.getMessage('validation.error_user_no_set_up'));
      this.currentTab = 0;
      return;
    }

    this.dataFootNote.map((item, index) => {
      // nếu có 1 thằng khách hàng thôi thì map luôn chân ký cho thằng đầu tiên
      if (item.signature &&
        item.signature.object
        && item.signature.object === 'CUSTOMER' && this.maxNumberOfCustomerInFlow == 1) {
        item.customerOrder = 1;
      }
    });
    // nếu chưa cấu hình hết chân ký cho khách hàng thì mở popup thông báo
    // tìm một thằng khách hàng có customerOrder = null
    if(this.signatureConfigComponent.dataFootNote){
      let totalNotConfig = this.signatureConfigComponent.dataFootNote.filter(item =>{
        if (item.signature &&
          item.signature.object
          && item.signature.object === 'CUSTOMER' && !item.customerOrder) {
          return true;
        }else {
          return false;
        }
      });

      if(totalNotConfig && totalNotConfig.length > 0){
        const dialog = this.dialog.open(WarningComponent, {
          width: '40%',
          data: this.message.getMessage('add_document_moha.signature_not_configured_confirm')
        });
        let res = await dialog.afterClosed().toPromise();
        if (!res) {
          this.expansionData.open();
          this.currentTab = 1;
          return;
        }
      }
    }

    this.standardizedData();
    const data: ContractLot = ContractLot.build();
    data.enterpriseSign = this.configSignComponent.RECORD_PARTY_SIGN;
    data.userSign = this.createSide ? this.configSignComponent.RECORD_USER_PERFORM_SIGN.map((data) => ({
      ...data,
      signConfig: JSON.stringify(data.signConfig)
    })) : [];
    if (this.createSide && this.configSignComponent.RECORD_USER_PERFORM_SIGN) {
      const userSignIndex = this.configSignComponent.RECORD_USER_PERFORM_SIGN.findIndex(item => item.role === EnumRoleUser.USER_SIGN);
      // Di chuyển userSign về cuối mảng
      if (userSignIndex != -1) {
        let userSign = this.configSignComponent.RECORD_USER_PERFORM_SIGN.splice(userSignIndex, 1)[0];
        this.configSignComponent.RECORD_USER_PERFORM_SIGN.push(userSign);
      }
      // Cập nhật lại order cho các phần tử khác trong mảng
      for (let i = 0; i < this.configSignComponent.RECORD_USER_PERFORM_SIGN.length; i++) {
        this.configSignComponent.RECORD_USER_PERFORM_SIGN[i].order = i + 1;
      }
    }
    data.importFileBase64 = this.fileBase64.replace('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,', '');
    data.importFileName = this.fileName;
    data.documentTypeEnterpriseId = this.documentTypeEnterprise.id;
    data.signatures = this.signatureConfigComponent.dataFootNote ? this.signatureConfigComponent.dataFootNote : this.dataFootNote;
    data.signatures = data.signatures.filter(item => !item.deleteCreateSide);

    data.maxPartnerNumber = this.maxNumberOfCustomerInFlow;
    data.contractSharePartners = this.RECORD_SHARE_PARTNER
    data.type = "CONTRACT_MOHA";
    this.contractLotService.createContractLot(data).subscribe(res => {
      if (!res || !res.data) {
        if (res.message) {
          this.toast.error(res.message);
        }
        if (res.code === ErrorCode.FormatImportCustomerExcel || res.code === ErrorCode.EmptyImportCustomerExcel) {
          this.errorFile = true;
          setTimeout(() => {
            const element = document.getElementsByClassName('error-file');
            element.item(0).scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
          })
        }
        return;
      }
      this.contractLotService.processingStart.next(true);
      this.blockUI.reset();
      this.blockUI.start();
      setTimeout(() => {
      this.router.navigateByUrl(`/home-enterprise/contract-lot-moha/${res.data}`);
      this.blockUI.stop();
      }, 5000);  
    })
  }


  genSignature(id: string, users: any) {
    this.documentTemplateService.getSignature(id).subscribe(res => {
      if (!res || !res.data) {
        return;
      }
      const enterprise = users.find(item => item.isCreatedSide);
      this.createSide = enterprise;
      let filled = false;
      this.dataFootNote = res.data.map(item => {
        if (item.signature) {
          const page = [];
          if (item.signature.positions) {
            item.signature.positions.forEach(pos => {
              if (pos.page && !page.includes(pos.page)) {
                page.push(pos.page);
              }
            });
          }
          item.signature.page = page.join(', ');
          if (item.signature.object && item.signature.object !== 'ENTERPRISE' && item.signature.object !== 'ENTERPRISEAPPROVER' && !filled) {
            item.customer = true;
            filled = true;
          } else {
            item.customer = false;
          }
        }
        return item;
      });
      // đếm số lượng chân ký của khách hàng trong mẫu
      let lsCustomerSignature = res.data.filter(item => {
        if (item.signature
          && item.signature.object
          && item.signature.object !== 'ENTERPRISE'
          && item.signature.object !== 'ENTERPRISEAPPROVER') {
          return true;
        } else {
          return false;
        }
      });

      this.maxNumberOfCustomerInFlow = lsCustomerSignature.length;
      if (!this.maxNumberOfCustomerInFlow || this.maxNumberOfCustomerInFlow <= 0) {
        this.maxNumberOfCustomerInFlow = 1;
        this.isContainCustomerSignature = false;
      } else {
        this.isContainCustomerSignature = true;
      }
      this.noteWarning = this.commonService.format(this.message.getMessage('contract_lot.note_warning'), this.maxNumberOfCustomerInFlow);
      // nếu có 1 thằng khách hàng thôi thì map luôn chân ký cho thằng đầu tiên
    });
  }

  getDefault(event: any) {
    this.genSignature(this.documentTypeEnterprise.id, event);
  }

  useCreateSide(event: any) {
    this.createSide = event;
  }

  openTabSign(event) {
    if (event.index === 1) {
      const isCreateSide = this.configSignComponent.RECORD_PARTY_SIGN.filter(item => item.isCreatedSide == true)
      if (isCreateSide.length > 0) {
        this.isHaveDeleteCreata = false;
      } else {
        this.isHaveDeleteCreata = true;
      }
    }
    if (event.index === 1) {
      this.DATA_RECORD_USER_PERFORM_SIGN = this.configSignComponent.RECORD_USER_PERFORM_SIGN.filter((item) => item.role === EnumRoleUser.USER_APPROVER && item.isSignDigitalCertificate && (item && item.signConfig && item.signConfig.showImage));
    }
    if (event.index === 1 && this.checkFirtClick) {
      const listUserApprove = this.configSignComponent.RECORD_USER_PERFORM_SIGN;
      let indexApprover = 0;
      const approver = listUserApprove.filter(item => {
        return item.role === EnumRoleUser.USER_APPROVER && item.isSignDigitalCertificate && (item && item.signConfig && item.signConfig.showImage);
      });
      this.dataFootNote.map(item => {
        if (item.signature) {
          const page = [];
          if (item.signature.positions) {
            item.signature.positions.forEach(position => {
              if (position.page && !page.includes(position.page)) {
                page.push(position.page);
              }
            });
          }
          item.signature.page = page.join(', ');
          if (item.signature.object && item.signature.object === 'ENTERPRISEAPPROVER' && this.viewMode !== 'view') {
            item.userId = approver && approver[indexApprover] && approver[indexApprover].userId ? approver[indexApprover].userId : null;
            indexApprover++;
          }
        }
      });
      this.checkFirtClick = false;
    }
  }

  getBase64(file) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  renderNumber(type: 'total' | 'success' | 'error') {
    if (this.contractLot && this.contractLot.contractDetails) {
      switch (type) {
        case 'total':
          return this.contractLot.contractDetails.length;
        case 'error':
          return this.contractLot.contractDetails.filter(item => {
            return item.status === 'ERROR';
          }).length;
        case 'success':
          return this.contractLot.contractDetails.filter(item => {
            return item.status === 'DONE';
          }).length;
      }
    }
  }

  renderStatus(status: string) {
    switch (status) {
      case 'ERROR':
        return this.message.getMessage('contract_lot.status.error');
      case 'PROCESSING':
        return this.message.getMessage('contract_lot.status.processing');
      case 'DONE':
        return this.message.getMessage('contract_lot.status.done');
      default:
        return '';
    }
  }

  renderStatusColor(status: string): object {
    switch (status) {
      case 'ERROR':
        return {'color': 'red'};
      case 'PROCESSING':
        return {'color': 'blue'};
      default:
        return {'color': 'green'};
    }
  }

  preview() {
    this.templateFileService.getContentTemplateFileByUrl({
      type: 'TEMPLATE_PDF',
      url: this.templateFile.file.pdfUrl
    }).subscribe(rs => {
      if (!rs) {
        return;
      }
      this.dialog.open(DialogPreviewPdfComponent, {
        width: '80%',
        data: {
          file: rs,
          name: this.name,
        },
      });
    })
  }

  getResultFile() {
    this.contractLotService.getResultFile(this.id).subscribe(res => {
      this.downLoadFile(res, 'application/octet-stream', this.contractLot.code ? this.contractLot.code + '_ketqua.xlsx' : 'ketqua.xlsx');
    })
  }

  onClickCancel() {
    if (this.configSignComponent.isFormChanging || this.signatureConfigComponent.isChanging || this.fileName) {
      const confirmDialog = this.dialog.open(WarningComponent, {
        width: '40%',
        data: this.message.getMessage('messages.cancel_create_contract_lot')
      });
      confirmDialog.afterClosed().subscribe(ref => {
        if (ref) {
          this.location.back();
        }
      });
      return;
    }
    this.location.back();
  }

  setUserSign(name: string) {
    this.userSign = name;
  }

  setDataRecordUserPerformSign(event) {
    this.DATA_RECORD_USER_PERFORM_SIGN = event;
  }

  private standardizedData() {
    // Reorder party list
    this.configSignComponent.RECORD_PARTY_SIGN.sort((a, b) => (a.order - b.order));
    let nextOrder = 1;
    let currentOrder = this.configSignComponent.RECORD_PARTY_SIGN[0].order;
    this.configSignComponent.RECORD_PARTY_SIGN[0].order = 1;
    this.configSignComponent.RECORD_PARTY_SIGN.forEach((item) => {
      if (item.order > currentOrder) {
        nextOrder += 1;
        currentOrder = item.order;
      }
      item.order = nextOrder;
    });

    // Kiểm tra danh sách bên ký kết có bên Lập không
    // Nếu ko có >> xóa trắng danh sách người dùng ký kết
    const existedList = this.configSignComponent.RECORD_PARTY_SIGN.filter((e) => {
      return e.isCreatedSide === true && e.isCreatedSideJoin;
    });

    if (existedList.length <= 0) {
      this.configSignComponent.RECORD_USER_PERFORM_SIGN = [];
      this.configSignComponent.RECORD_PARTY_SIGN.forEach(item => {
        if (!item.isCreatedSide) {
          item.order = 1;
        } else {
          item.order = 0;
        }
      });
    }
  }

  sortOrderApproveSign() {
    let newOrder = 0;
    let RECORD_USER_APPROVE = [...this.configSignComponent.RECORD_USER_PERFORM_SIGN.filter(item => item.role === EnumRoleUser.USER_APPROVER)];
    let RECORD_USER_SIGN = [...this.configSignComponent.RECORD_USER_PERFORM_SIGN.filter(item => item.role === EnumRoleUser.USER_SIGN)];

    if (RECORD_USER_APPROVE.length) {
      RECORD_USER_APPROVE.sort((a, b) => {
        return a.order - b.order;
      });

      RECORD_USER_APPROVE = RECORD_USER_APPROVE.map((item, index) => {
        if (index === 0) {
          newOrder = 1;
          return {
            ...item,
            order: 1
          }
        } else {
          if (item.order !== RECORD_USER_APPROVE[index - 1].order) {
            newOrder++;
          }
          return {
            ...item,
            order: newOrder
          }
        }
      });

      RECORD_USER_SIGN = RECORD_USER_SIGN.map((item) => ({
        ...item,
        order: RECORD_USER_APPROVE[RECORD_USER_APPROVE.length - 1].order + 1
      }))
    }

    const RECORD_USER_PERFORM_SIGN = RECORD_USER_APPROVE.concat(RECORD_USER_SIGN);

    this.configSignComponent.RECORD_USER_PERFORM_SIGN = RECORD_USER_PERFORM_SIGN;
  }
  
  onChangePartySignSearch($event: any): void {
    this.filteredPartyOptions = [];
    if ($event.inputType.includes('insert') || $event.inputType.includes('delete')) {
      if (this.timeOutQueryServer) {
        clearTimeout(this.timeOutQueryServer);
      }
      this.timeOutQueryServer = setTimeout(() => {
        if (this.inputPartyValue.trim().length > 0) {
          this.nzCheckLoadingParty2 = true;
          this.autoEnterpriseService.fetchAuto(this.inputPartyValue.trim())
            .then(result => {
              this.filteredPartyOptions = [];
              if (result) {
                for (const item of result) {
                  if (!item.isCreatedSide) {
                     if (!this.checkExistedParty(item.enterpriseId, item.customerId)) {
                      const existedList = this.filteredPartyOptions.filter((e) => {
                        return e.enterpriseId === item.enterpriseId;
                      });
                      this.filteredPartyOptions.push(item);
                    }
                  } 
                }
              }
            }).finally(() => {
              this.nzCheckLoadingParty2 = false;
            });
        } else {
          this.inputPartyValue = '';
        }
      }, 500);

    }
  }
  autocompletePartySelected($event: any, model: any) {
    if ($event.isUserInput) {
      if (!this.checkExistedParty(model.enterpriseId, model.customerId)) {
        this.RECORD_SHARE_PARTNER = [
          ...this.RECORD_SHARE_PARTNER,
          {
            enterpriseId: model.enterpriseId,
            customerId: model.customerId,
            email: model.email,
            name: model.name,
            phone: model.phone,
            permission: 'FILE'
          }
        ];
        this.inputPartyValue = '';
        this.filteredPartyOptions = [];
      } else {
        this.toast.error(this.commonService.format(this.message.getMessage('messages.add_party_apostrophe_duplicate'), model.name));
      }
    }
  }
  checkExistedParty(enterpriseId: string, customerId: string) {
    const existedList = this.RECORD_SHARE_PARTNER.filter((e) => {
      return enterpriseId ? e.enterpriseId === enterpriseId : e.customerId === customerId;
    });

    return (existedList.length > 0);
  }
  onClickDeleteElementRecordParty(enterpriseId: any, customerId:any): void {
    if (enterpriseId && enterpriseId.length > 0) {
      this.RECORD_SHARE_PARTNER = this.RECORD_SHARE_PARTNER.filter(d => d.enterpriseId !== enterpriseId);
    } else {
      this.RECORD_SHARE_PARTNER = this.RECORD_SHARE_PARTNER.filter(d => d.customerId !== customerId);
    }
  }

  private mapContractReportRows(rows: any[]): any[] {
    return (rows || []).map(row => {
      const fieldsByKey = new Map<string, any>();
      (row.contractMohaFields || []).forEach(field => {
        fieldsByKey.set(field.key, field);
      });

      const reportFields = this.dynamicColumns.map(column => {
        const field = fieldsByKey.get(column.code);
        return {
          ...column,
          key: column.code,
          value: field ? field.value : null
        };
      });

      return {
        ...row,
        reportFields
      };
    });
  }

  // Gom cột động theo tên cha gần nhất (các section trùng tên gộp chung 1 nhóm),
  // giống bảng lịch sử tiêu chí ở màn chi tiết
  buildGroupColumns(dataStandard: any[]) {
    const fieldByCode = new Map<string, any>();
    (dataStandard || []).forEach(f => {
      if (f.code && !fieldByCode.has(f.code)) fieldByCode.set(f.code, f);
    });

    const groupNameOf = (f: any): string => {
      const parent = f.parentCode ? fieldByCode.get(f.parentCode) : null;
      return parent ? String(parent.name || parent.code || '').trim() : '';
    };

    const groupOrder: string[] = [];
    const buckets = new Map<string, any[]>();
    this.dynamicColumns.forEach((f: any) => {
      const g = groupNameOf(f);
      let bucket = buckets.get(g);
      if (!bucket) {
        bucket = [];
        buckets.set(g, bucket);
        groupOrder.push(g);
      }
      bucket.push(f);
    });
    const orderedColumns: any[] = [];
    groupOrder.forEach(g => orderedColumns.push(...(buckets.get(g) || [])));
    this.dynamicColumns = orderedColumns;

    this.lotGroupColumns = [];
    this.lotGroupRowColumns = [];
    orderedColumns.forEach(f => {
      const g = groupNameOf(f);
      const last = this.lotGroupColumns[this.lotGroupColumns.length - 1];
      if (g && last && last.name === g) {
        last.span++;
      } else {
        this.lotGroupColumns.push({ name: g, span: 1 });
        this.lotGroupRowColumns.push('lot_group_' + (this.lotGroupColumns.length - 1));
      }
    });
  }
}
